import type { PiniaPlugin } from 'pinia';
import {
    AI_BUILDER_SETTING_NAME,
    AI_BUILDER_SETTING_VALUES,
} from '@/constants/ai-builder-user-setting.constants';

export const analyticsPlugin: PiniaPlugin = ({ store }) => {
    if (store.$id === 'auth') {
        store.$onAction(({ name, args, after }) => {
            if (name !== 'setProperty') return;
            const payload = args[0] as { property?: string; reIdentify?: boolean };
            if (
                !payload.reIdentify ||
                !['first', 'last', 'jobRole', 'useCase'].includes(payload.property || '')
            ) {
                return;
            }
            after(() => {
                // eslint-disable-next-line @typescript-eslint/no-require-imports
                const { identify }: typeof import('@/plugins/analytics') = require('@/plugins/analytics');
                identify();
            });
        });
    }

    if (store.$id === 'userSettings') {
        store.$onAction(({ name, args, after }) => {
            if (name !== 'update') return;
            const payload = args[0] as {
                force?: boolean;
                name?: string;
                namespaced?: boolean;
                value?: unknown;
            };
            const isAiBuilderSetting =
                payload.name === AI_BUILDER_SETTING_NAME && payload.namespaced === true;
            const isValidAiBuilderValue = Object.values(AI_BUILDER_SETTING_VALUES).some(
                (value) => value === payload.value,
            );
            const currentAiBuilderValue = store.settingByName(AI_BUILDER_SETTING_NAME, true)?.value;
            const hasAiBuilderValueChanged = currentAiBuilderValue !== payload.value;
            const shouldSyncAiBuilder =
                isAiBuilderSetting &&
                isValidAiBuilderValue &&
                (payload.force || hasAiBuilderValueChanged);
            const shouldIdentifyDiscoverPreferences =
                payload.name?.startsWith('discoverGetStartedPreferences') === true;
            if (!shouldSyncAiBuilder && !shouldIdentifyDiscoverPreferences) return;
            after(() => {
                if (shouldSyncAiBuilder) {
                    const { visitor } = window.pendo?.getSerializedMetadata?.() ?? {};
                    window.pendo?.updateOptions?.({
                        visitor: {
                            ...visitor,
                            [AI_BUILDER_SETTING_NAME]: payload.value,
                        },
                    });

                    return;
                }

                // eslint-disable-next-line @typescript-eslint/no-require-imports
                const { identify }: typeof import('@/plugins/analytics') = require('@/plugins/analytics');
                identify();
            });
        });
    }
};
